import React from 'react';
import { LayoutGrid, List } from 'lucide-react';
import { Button } from '../ui/Button';

interface ViewToggleProps {
  view: 'grid' | 'list';
  onViewChange: (view: 'grid' | 'list') => void;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({ view, onViewChange }) => {
  return (
    <div className="flex gap-2">
      <Button
        variant={view === 'grid' ? 'primary' : 'secondary'}
        size="icon"
        onClick={() => onViewChange('grid')}
        title="Vue en grille"
      >
        <LayoutGrid className="h-4 w-4" />
      </Button>
      <Button
        variant={view === 'list' ? 'primary' : 'secondary'}
        size="icon"
        onClick={() => onViewChange('list')}
        title="Vue en liste"
      >
        <List className="h-4 w-4" />
      </Button>
    </div>
  );
};